export const GSTATIC_FONTS = "https://fonts.gstatic.com"

export const GOOGLE_FONTS_CSS = "https://fonts.googleapis.com/css"
